import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import UpperCaseText from "../../../utils/UpperCaseText";
import EMPOrderTable from "../../../shared/components/EMPOrderTable/EMPOrderTable";

// Search API dates come back as MM-DD-YYYY, which Date() can't parse reliably
const parseSearchDate = (value) => {
  const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value || "");
  return match ? new Date(match[3], match[1] - 1, match[2]) : value;
};

export const toOrderTableRow = (order) => ({
  ...order,
  orderIdString: String(order.id),
  orderDate: parseSearchDate(order.createdDate ?? order.date),
  orderStatus: order.businessStatus,
  vin: order.vinNumber,
});

class SearchOrdersResults extends Component {
  render() {
    const ordersData = this.props.orders?.filter(
      (order) => order.orderType && UpperCaseText(order.orderType) === "ORDER"
    );

    const canSeeCustomerName = Object.hasOwn(
      this.props.user.permissions?.rolePermissions ?? {},
      "customerNameColumnInCHGrid"
    );

    return ordersData && ordersData.length !== 0 ? (
      <EMPOrderTable
        rows={ordersData.map(toOrderTableRow)}
        hiddenColumns={canSeeCustomerName ? [] : ["customerName"]}
        emptyCellText="-"
      />
    ) : (
      this.props.noContentText &&
        this.props.getNoContent(this.props.noContentText)
    );
  }
}

SearchOrdersResults.propTypes = {
  orders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      orderType: PropTypes.string,
      createdDate: PropTypes.string,
      date: PropTypes.string,
      businessStatus: PropTypes.string,
      customerName: PropTypes.string,
      vinNumber: PropTypes.string,
    })
  ),
  user: PropTypes.shape({
    permissions: PropTypes.shape({
      rolePermissions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    }),
  }).isRequired,
  noContentText: PropTypes.string,
  getNoContent: PropTypes.func,
};

SearchOrdersResults.defaultProps = {
  orders: undefined,
  noContentText: undefined,
  getNoContent: undefined,
};

export default withTranslation("emp")(SearchOrdersResults);
